import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {User} from '@app/models/user.model';

@Injectable({providedIn: 'root'})
export class GSheetService {
  private http = inject(HttpClient);
  private scriptUrl = 'https://script.google.com/macros/s/AKfycbwxYa6PJKFtMALncqtQMhoVdcjPdVaYOvaNuBWZ8l7P4IwNn0hrsQFGZe3zd0N9tx5uCA/exec';

  saveResult(userData: User, token: string) {
    return this.http.post(this.scriptUrl, JSON.stringify({...userData, token}), {
      headers: { 'Content-Type': 'text/plain' }
    });
  }
}
